import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLightning16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLightning16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.988 10.14c-.88-.002-1.318-1.09-.696-1.726l6.952-7.112c.74-.758 1.974.029 1.635 1.043L9.762 5.68h3.249c.88 0 1.322 1.09.699 1.726l-7.131 7.295c-.743.76-1.979-.033-1.633-1.048l1.195-3.504zm6.955-8.123L2.991 9.13l3.847.012.694.002-.229.67-1.423 4.174 7.131-7.295H8.379l.224-.67z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLightning16);
